export default "__VITE_ASSET__CqmzAKn2__"